import { render, staticRenderFns } from "./rich-text.vue?vue&type=template&id=4d6b7314"
import script from "./rich-text.vue?vue&type=script&lang=js"
export * from "./rich-text.vue?vue&type=script&lang=js"
import style0 from "./rich-text.vue?vue&type=style&index=0&id=4d6b7314&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports